export default "ldi"